import { jsx as e, jsxs as m } from "react/jsx-runtime";
import r from "./breadcrumbs.module.less.js";
import { BreadcrumbsList as t } from "../breadcrumbs-list/breadcrumbs-list.js";
import n from "../link-wrapper/link-wrapper.js";
import { useTranslation as l } from "react-i18next";
import { useAnimateFadeIn as c } from "../../../animation/animation.js";
import { m as d } from "motion/react";
const N = ({ items: a, logoUrl: s }) => {
  if (!a)
    return null;
  const i = c({ whileInView: !1, easing: "easeInOut" }), { t: o } = l();
  return /* @__PURE__ */ e("section", { className: `${r.section}`, children: /* @__PURE__ */ m(d.div, { ...i, className: `${r.wrapper} centered max-width padded-sides`, children: [
    s && /* @__PURE__ */ e(n, { ariaLabel: o("HEADER_LOGO_LINK_ARIA_LABEL"), className: r.logoWrapper, url: "/", children: /* @__PURE__ */ e("img", { src: s, alt: "Preem logo", className: r.logo }) }),
    /* @__PURE__ */ e(t, { items: a })
  ] }) });
};
export {
  N as Breadcrumbs,
  N as default
};
